export { default } from './GridInfoPages.vue'
